module.exports = __webpack_public_path__ + "static/media/align-center.76561b11.svg";